{
  "version": 1,
  "eraStatus": "pinned later source candidate; exact 2009 recording not authenticated",
  "rules": {
    "defaultGain": 0.5,
    "repeat": true,
    "sourcePlaylist": [
      "map.BackMusic",
      "map.BackMusic"
    ],
    "stopOnGameOver": true,
    "playlistSemantics": "playMusicImp selects list[0]; Play.Stop passes the unchanged list back, so the same map track repeats indefinitely.",
    "muteSemantics": "Source zeroes stream volume without pausing; browser stops its voice on reset and resumes at the elapsed loop offset."
  },
  "maps": {
    "1030": {
      "url": "/game/audio/map-1030.mp3",
      "musicId": "1030",
      "duration": 161.77632653061224,
      "startOffset": 0,
      "sampleRate": 22050,
      "channels": 2
    },
    "1031": {
      "url": "/game/audio/map-1031.mp3",
      "musicId": "1031",
      "duration": 83.40897959183674,
      "startOffset": 0,
      "sampleRate": 22050,
      "channels": 2
    },
    "1034": {
      "url": "/game/audio/map-1034.mp3",
      "musicId": "1034",
      "duration": 124.83918367346939,
      "startOffset": 0,
      "sampleRate": 22050,
      "channels": 2
    },
    "1001": {
      "url": "/game/audio/map-1001.mp3",
      "musicId": "1001",
      "duration": 144.09142857142857,
      "startOffset": 0,
      "sampleRate": 22050,
      "channels": 2
    }
  },
  "provenance": "research/source-inspection/battle-music-audit/provenance.json"
}
